import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

//* HOCs
import { withUserContext } from 'context'

//* Components
import { Icon, Text } from 'components/common'

//* Style
import ButtonFollowStyle from './style'

const ButtonFollow = (props) => {
    const [isFollow, setIsFollow] = useState(false)

    const router = useRouter()

    const handleFollow = () => {
        if (props.isLoggedIn) {
            return props.toggleFollow(props.followingId).then(() => {
                setIsFollow(!isFollow)
            })
        } else {
            router.push(`${router.asPath}?c=login`)
        }
    }

    useEffect(() => {
        if (props.isLoggedIn) {
            setIsFollow(props?.user?.following?.includes(props.followingId))
        }
    }, [props.user, props.isLoggedIn])


    return props?.user?.id != props.followingId && (
        <ButtonFollowStyle className={`flexBox ${props.className}`} onClick={handleFollow}>
            {isFollow ?
                <>
                    <Icon className='op-mark h8' />
                    <Text tag={'p'} className={'h8 PopReg text'} text={'Following'} />
                </>
                :
                <>
                    <Text tag={'p'} className={'h8 PopReg'} text={'+ '} />
                    <Text tag={'p'} className={'h8 PopReg text'} text={'Follow'} />
                </>
            }
        </ButtonFollowStyle>
    )
}

export default withUserContext(ButtonFollow, ['user', 'toggleFollow', 'isLoggedIn'])
